import createIcon from '../../createIcon';

/**
 * @component @name AccountBalance
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxMUg1VjE4SDdWMTFaTTEzIDExSDExVjE4SDEzVjExWk0yMS41IDIwSDIuNVYyMkgyMS41VjIwWk0xOSAxMUgxN1YxOEgxOVYxMVpNMTIgNC4yNkwxNy4yMSA3SDYuNzlMMTIgNC4yNlpNMTIgMkwyLjUgN1Y5SDIxLjVWN0wxMiAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccountBalance = createIcon('AccountBalance', [
  [
    'path',
    {
      d: 'M7 11H5V18H7V11ZM13 11H11V18H13V11ZM21.5 20H2.5V22H21.5V20ZM19 11H17V18H19V11ZM12 4.26L17.21 7H6.79L12 4.26ZM12 2L2.5 7V9H21.5V7L12 2Z',
      key: '1tea8l',
    },
  ],
]);

export default AccountBalance;
